import { render, staticRenderFns } from "./StudyResultsContentCard.vue?vue&type=template&id=58519d54&scoped=true&"
import script from "./StudyResultsContentCard.vue?vue&type=script&lang=js&"
export * from "./StudyResultsContentCard.vue?vue&type=script&lang=js&"
import style0 from "./StudyResultsContentCard.vue?vue&type=style&index=0&id=58519d54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58519d54",
  null
  
)

export default component.exports